import { render, staticRenderFns } from "./LF.vue?vue&type=template&id=14bc3353&"
import script from "./LF.vue?vue&type=script&lang=js&"
export * from "./LF.vue?vue&type=script&lang=js&"
import style0 from "./LF.vue?vue&type=style&index=0&id=14bc3353&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports